import { IMAGES, waLink } from "@/lib/site";
import { Reveal } from "@/components/Reveal";
import { StarField } from "@/components/StarField";
import { useLang } from "@/i18n";

export const Guidance = () => {
    const { t } = useLang();
    const words = t("guidance.keywords");

    return (
        <section id="guia" data-testid="guidance-section" className="relative py-24 sm:py-32 px-5 sm:px-8 overflow-hidden bg-burgundy-dark">
            <div
                className="absolute inset-0 bg-cover bg-center opacity-[0.14]"
                style={{ backgroundImage: `url(${IMAGES.buddha})` }}
                aria-hidden="true"
            />
            <div
                className="absolute inset-0 pointer-events-none candle-glow"
                style={{ background: "radial-gradient(ellipse 60% 45% at 50% 55%, rgba(212,175,55,0.1) 0%, transparent 70%)" }}
                aria-hidden="true"
            />
            <StarField count={35} />
            <div className="absolute top-0 left-0 right-0 h-28 section-fade-top" aria-hidden="true" />
            <div className="absolute bottom-0 left-0 right-0 h-28 section-fade-bottom" aria-hidden="true" />

            <div className="relative max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-[0.85fr_1.15fr] gap-12 lg:gap-16 items-center">
                <Reveal className="order-2 lg:order-1">
                    <div className="relative mx-auto w-60 sm:w-72 lg:w-full lg:max-w-sm">
                        <div
                            className="absolute -inset-6 rounded-t-full candle-glow"
                            style={{ background: "radial-gradient(ellipse 65% 55% at 50% 45%, rgba(212,175,55,0.2) 0%, transparent 70%)" }}
                            aria-hidden="true"
                        />
                        <div
                            data-testid="guidance-portrait-frame"
                            className="relative border border-gold/50 rounded-t-full overflow-hidden shadow-[0_0_45px_rgba(212,175,55,0.2)]"
                        >
                            <img
                                src="/images/retrato.jpg"
                                alt="Consejero espiritual de Yerberia Jardin D'Venuz con su gato"
                                loading="lazy"
                                className="w-full aspect-[37/38] object-cover object-top"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-burgundy-dark/50 via-transparent to-transparent pointer-events-none" aria-hidden="true" />
                            <div className="absolute inset-2.5 border border-gold/35 rounded-t-full pointer-events-none" aria-hidden="true" />
                        </div>
                        <p className="text-center font-accent text-[10px] tracking-[0.3em] uppercase text-gold-soft mt-5">
                            {t("guidance.caption")}
                        </p>
                    </div>
                </Reveal>

                <div className="order-1 lg:order-2 text-center lg:text-left">
                    <Reveal>
                        <h2 className="font-display font-semibold gold-text text-4xl sm:text-5xl leading-tight tracking-wide">
                            {t("guidance.title")}
                        </h2>
                    </Reveal>
                    <Reveal delay={0.12}>
                        <p className="text-sm sm:text-base text-cream/70 font-light leading-relaxed mt-7 max-w-xl mx-auto lg:mx-0">
                            {t("guidance.text")}
                        </p>
                    </Reveal>
                    <Reveal delay={0.2}>
                        <p className="flex flex-wrap justify-center lg:justify-start gap-x-1 gap-y-2 font-accent text-[11px] sm:text-xs tracking-[0.3em] uppercase text-gold-soft mt-9" data-testid="guidance-keywords">
                            {words.map((w, i) => (
                                <span key={w} className="whitespace-nowrap">
                                    {w}
                                    {i < words.length - 1 && <span className="text-gold/50 mx-3">·</span>}
                                </span>
                            ))}
                        </p>
                    </Reveal>
                    <Reveal delay={0.28}>
                        <a
                            href={waLink(t("wa.guidance"))}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="guidance-whatsapp-button"
                            className="inline-block mt-10 bg-gold text-ink font-accent text-xs tracking-[0.22em] uppercase font-bold px-10 py-4 rounded-sm hover:brightness-110 hover:shadow-[0_0_30px_rgba(212,175,55,0.4)] hover:-translate-y-0.5 transition-[box-shadow,transform,filter] duration-300"
                        >
                            {t("guidance.cta")}
                        </a>
                    </Reveal>
                </div>
            </div>
        </section>
    );
};
